export function getDebraApiRestEndpoint() {
  return process.env.VUE_APP_DEXTR_DEBRA_APIG_URL;
}
